(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["app-ios-browser-banner"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var banner = document.getElementById('app-ios-browser-banner');
    if (!banner) return;
    var ua = navigator.userAgent || '';
    if (!/iPhone|iPod/i.test(ua) || navigator.standalone) return;
    var otherBrowser = /CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo|FBAN|FBAV|Instagram|Pinterest|TikTok|GSA|Line\//i.test(ua);
    if (/Version\/[\d.]+.*Safari\//i.test(ua) && !otherBrowser) return;

    var storageKey = 'app-ios-browser-banner-dismissed-v1';
    try {
      var dismissedAt = Number(localStorage.getItem(storageKey));
      if (dismissedAt && Date.now() - dismissedAt < 30 * 24 * 60 * 60 * 1000) return;
    } catch (error) {}

    banner.hidden = false;
    banner.querySelector('.app-ios-browser-banner__close').addEventListener('click', function () {
      banner.hidden = true;
      try { localStorage.setItem(storageKey, String(Date.now())); } catch (error) {}
    });
  });
  } catch(e) { console.error(e); }
})();

})();
